import React from "react";
import { useNavigate } from "react-router-dom";

import "../styles/PageNotFound.css";

const PageNotFound = () => {

  const navigate = useNavigate();

  return (
    <div className="not-found-page">

      <div className="not-found-card">

        <div className="not-found-icon">
          <i className="bi bi-lock"></i>
        </div>

        <div className="not-found-code">
          401
        </div>

        <h2>
          Authentication Required
        </h2>

        <p>
          The resource you tried to access 
          admin or user authentication. to proceed please Log into your acccount
        </p>

        <div className="not-found-actions">
          <div className="flex">
          <button
            className="btn btn-primary m-2"
            onClick={() => navigate('/')}
          >
            <i className="bi bi-house m-2"></i>
            Home
          </button>
          <button
            className="btn btn-primary m-2"
            onClick={() => navigate('/login')}
          >
            <i className="bi bi-person-lock m-2"></i>
            Login
          </button>
          </div>

        </div>

      </div>

    </div>
  );

};

export default PageNotFound;